
import { defineComponent, reactive, ref } from "vue";
import { tableHeader, ToiawaseList } from "./config";
import { ELEMENT_ACCESS } from "@/constants/accessList.constant";
import useTable from "@/hooks/useTable";
import { QueryToiawase } from "@/interfaces/toiawase.interface";
import { useRouter } from "vue-router";
import { getToiawaseList } from "@/api/toiawase.api";
import { getToiawaseJokyoList } from "@/api/masterTable.api";
import { toiawaseJokyoMaster } from "@/interfaces/masterTable.interface";
import { dateFormat } from "@/utils/date";
import { export2Excel } from "./common";
export default defineComponent({
  setup() {
    // ステータスリスト
    const toiawaseJokyoOptions = ref<toiawaseJokyoMaster[]>();
    getToiawaseJokyoList().then((res) => {
      toiawaseJokyoOptions.value = res;
    });
    const showDetailSearch = ref(false); //詳細検索欄表示制御

    const table = reactive({
      queryForm: {
        toiawaseJokyoCd: "",
        kjnNm: "",
        kaishaNm: "",
        page: 1,
        limit: 20,
      } as QueryToiawase,
      list: [] as ToiawaseList[],
      total: 0,
      loading: true,
    });

    // 検索
    //検索結果設定
    const getList = async () => {
      table.loading = true;
      table.list = [];
      const { data } = await getToiawaseList(table.queryForm);
      const { listData, total } = data.result;
      table.total = total;
      for (let i = 0; i < listData.length; i++) {
        table.list.push({
          id: listData[i].id,
          toiawaseId: listData[i].toiawase_id,
          toiawaseJokyo: listData[i].jokyo.toiawase_jokyo,
          createdDate: dateFormat(listData[i].toroku_date),
          kjnNm: listData[i].kjn_nm,
          kaishaNm: listData[i].kaisha_nm,
          toiawaseKenmei: listData[i].toiawase_kenmei,
        });
      }

      table.loading = false;
    };

    const tableRef = ref();
    const { handleSizeChange, handleSearch, handleClear } = useTable(
      table,
      getList,
      tableRef
    );

    // 申請登録画面 or 申請編集画面に遷移するのを制御
    const router = useRouter();
    const goToDetail = (id: string) => {
      router.push({ name: "toiawaseForm", params: { id } });
    };
    getList();

    //excel出力イベント
    const { exportLoading, handleExport2excel } = export2Excel(table.queryForm);

    return {
      table,
      tableHeader,
      getList,
      handleClear,
      handleSearch,
      handleSizeChange,
      ELEMENT_ACCESS,
      handleExport2excel,
      exportLoading,
      toiawaseJokyoOptions,
      showDetailSearch,
      goToDetail,
      tableRef,
    };
  },
});
